import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import {
  Grid,
  Button,
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
  Input,
  CircularProgress,
  Backdrop
} from '@material-ui/core';
import moment from 'moment';
import SaveIcon from '@material-ui/icons/Save';
import DirectionsRunIcon from '@material-ui/icons/DirectionsRun';
import LoopIcon from '@material-ui/icons/Loop';
import Controls from '../controls/Controls';
import { baseUrl } from '../../utils/constants';
import { useSettingContext } from '../../context/setting_context';

/* eslint-disable camelcase */
function CycleMgmtSub(props) {
  const { closePopup, id } = props;
  const { currentCycle, getCycle, currentCycleId } = useSettingContext();
  const [errors, setErrors] = useState('');
  const [loading, setLoading] = useState(false);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const navigate = useNavigate();

  const CycleLineSchema = Yup.object().shape({
    payDate: Yup.date().required('you must specify the Stroke Beginning Date'),
    payCycleId: Yup.number()
      .required('you must specify the Stroke #')
      .min(1, 'please specify the stroke #')
  });

  const formik = useFormik({
    initialValues: currentCycle,
    enableReinitialize: true,
    validationSchema: CycleLineSchema,
    onSubmit: (values) => {
      console.log('claim line details ', values);
      saveCycle(values);
    }
  });

  console.log('currentCycle', currentCycle);
  if (currentCycle.payDate)
    currentCycle.payDate = moment(currentCycle.payDate).format('yyyy-MM-DD');

  useEffect(() => {
    if (currentCycleId > 0) {
      getCycle(currentCycleId);
    }
    if (id > 0) {
      getCycle(id);
    } else {
      getNextCycle();
      // setNew(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentCycleId]);

  const saveCycle = (line) => {
    const jsonClient = [];
    jsonClient.push(line);
    console.log('SavePayCycle b4 save', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/setting/SavePayCycle`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (result) => {
          notifyPopup(`Pay Cycle Saved Successfully!`, 'success');
          navigate(`/`);
          closePopup();
        },
        (error) => {
          notifyPopup(`Error in Saving Pay Cycle!: ${error}`, 'error');
        }
      );
  };

  const getNextCycle = async (e) => {
    console.log('e journaltype', e);
    setLoading(true);
    await axios(`${baseUrl}/api/setting/GetNextCycle`).then(
      (res) => {
        setLoading(false);
        console.log('returned GetNextCycle', res);
        formik.setFieldValue('payCycleId', res.data.refId);
      },
      (error) => {
        setLoading(false);
        notifyPopup(`Error in GetNextCycle!: ${error}`, 'error');
      }
    );
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const handleMouseDownPassword = (event) => {
    console.log('mouse down');
    event.preventDefault();
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  /* eslint-disable camelcase */
  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate>
        <Grid container spacing={2}>
          <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading}
            onClick={handleLoadingClose}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <Box>
            <Typography color="error" variant="h6">
              {errors && <div>{errors}</div>}
            </Typography>
          </Box>
          <Grid item xs={12} sm={4} ml={12}>
            <Controls.Input name="payCycleId" label="Stroke #" disabled />
          </Grid>
          <Grid item xs={12} sm={10} ml={12}>
            <Controls.DateTime name="payDate" label="Begin Stroke Date" />
          </Grid>
          <Grid item xs={12} sm={10} ml={12}>
            <Controls.Input name="rate" label="Stroke US$ Rate" />
          </Grid>
          <Grid item xs={12} sm={7}>
            <FormControlLabel
              control={<Checkbox checked={currentCycle.processed} name="processed" />}
              label="Run Monthly Bills"
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Button
              type="button"
              variant="outlined"
              startIcon={<DirectionsRunIcon />}
              disabled={formik.values.processed}
              // onClick={() => runProviderClaims()}
            >
              Run...
            </Button>
          </Grid>
          <Grid item xs={12} sm={7}>
            <FormControlLabel
              control={<Checkbox checked={currentCycle.selfPmts} name="selfPmts" />}
              label="Send Statements"
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Button
              type="button"
              variant="outlined"
              startIcon={<DirectionsRunIcon />}
              disabled={formik.values.selfPmts}
              // onClick={() => runSelfPaymentClaims()}
            >
              Run...
            </Button>
          </Grid>

          <Grid
            marginRight={4}
            container
            direction="row"
            justifyContent="right"
            alignItems="right"
            paddingRight={2}
          >
            <Grid item xs={12} sm={1} marginRight={1}>
              <Button
                type="submit"
                variant="contained"
                startIcon={<SaveIcon />}
                // disabled={currentCycle.payCycleId > 0}
              >
                Save...
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Controls.Notification notify={notify} setNotify={setNotify} />
      </Form>
    </FormikProvider>
  );
}

export default CycleMgmtSub;
